import { React, useState } from "react";
import Logo1 from "../img/Logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {faFacebook, faFacebookF, faGoogle, faYelp } from "@fortawesome/free-brands-svg-icons";
import { faBarsStaggered, faXmark, faPhone, faLocationDot } from "@fortawesome/free-solid-svg-icons"


function Navbar(props) {
    const [Click, setClick] = useState(false);
    const [Scroll, SetScroll] = useState(false);

    const Change_color = () => {
        if (window.scrollY >= 10) {
            SetScroll(true);
        }
        else { SetScroll(false); }
    };
    window.addEventListener('scroll', Change_color)
    const Icon_Style = { fontSize: '22', };
    return (
        <div className="">
            <nav className={Scroll ? "bg-black bg-opacity-25 shadow-lg px-4 transition ease-out duration-200  delay-100 flex font-header-font justify-between lg:justify-around w-full fixed top-0 left-0 right-0 z-10 " :
                "flex text-white justify-between lg:justify-around bg-none font-header-font w-screen fixed px-4 top-0 left-0 right-0 z-10"}>
                <div className="flex items-center cursor-pointer group">
                    <img src={Logo1} alt="" className=" w-24 md:w-32 group-hover:opacity-70" />
                </div>
                <div className={Scroll ? "lg:flex text-md hidden items-center space-x-20 text-xl capitalize text-white" :
                    "lg:flex text-md hidden items-center space-x-20 text-xl capitalize text-white"}>
                    <a onClick={() => props.handleTabClick("Home")} className={`${props.isActive("Home")} flex hover:text-main-color transition ease-in-out delay-150 duration-200`} href="/">
                        Home
                    </a>
                    <a onClick={() => props.handleTabClick("About")} className={`${props.isActive("About")} flex hover:text-main-color transition ease-in-out delay-150 duration-200`} href="/About">
                        About
                    </a>
                    <a onClick={() => props.handleTabClick("Services")} className={`${props.isActive("Services")} flex hover:text-main-color transition ease-in-out delay-150 duration-200`} href="/Services">
                        Services
                    </a>
                    <a onClick={() => props.handleTabClick("Contact")} className={`${props.isActive("Contact")} flex hover:text-main-color transition ease-in-out delay-150 duration-200`} href="/Contact">
                        Contact Us
                    </a>
                </div>
        
                <div className={Scroll ? "lg:hidden text-3xl cursor-pointer flex items-center text-black space-x-4" :
                    "lg:hidden space-x-4 blkock text-3xl cursor-pointer flex items-center"}>
                    {/* <div onClick={() => window.location.href = "tel:9516988897"} className={`${Scroll ? "bg-green-400" : "border-0"} p-[6px] rounded-full`}>
                        <FontAwesomeIcon className={`${Scroll ? "text-white" : "text-green-400"} flex text-sm`} icon={faPhone} />
                    </div>
                    <div onClick={(e) => { e.preventDefault(); window.open("https://maps.app.goo.gl/cotJyykT8YmggX7u8", '_blank') }} className={`${Scroll ? "" : "border-0"} p-2 rounded-full`}>
                        <FontAwesomeIcon className="flex !text-xl text-sky-400" icon={faLocationDot} />
                    </div> */}
                    <div onClick={() => setClick(!Click)} className={Scroll ? "lg:hidden transition text-3xl cursor-pointer flex items-center text-black space-x-4" : "lg:hidden space-x-4 text-3xl cursor-pointer flex items-center text-[#3C6CA8]"}>
                        {!Click ?
                            <FontAwesomeIcon className=" text-sky-400" icon={faBarsStaggered} /> :
                            <FontAwesomeIcon className=" text-sky-400" icon={faXmark} />
                        }
                    </div>
                </div>
                <div className={Scroll ? "hidden lg:flex items-center space-x-12 text-white" :
                    "hidden lg:flex items-center  space-x-12 text-white"}>
                    <button onClick={() => {
                        window.location.href = 'mailto:mai.kieu@m2precisionmachining.com';
                    }}
                        className= {Scroll? "transition ease-in-out duration-200 delay-100 group border-main2 hover:bg-main2 border-[1px] group cursor-pointer px-4 py-3 capitalize":"hover:bg-white/20 duration-200 ease-in-out delay-100 bg-main2 group cursor-pointer px-4 py-3 capitalize"}>
                        <a className = {Scroll?"group-hover:text-white transition ease-in-out duration-200 tracking-wider uppercase":"tracking-wider uppercase"}>Request Quote</a>
                    </button>
                </div>
            </nav>
            {Click ?
                <nav className="overflow-hidden space-y-12 md:space-y-24 top-20 md:top-28 fixed p-6 w-screen h-screen bg-sky-200 transition duration-700 ease-out lg:hidden left-0 right-0 z-20  mx-auto  text-black">
                    <div className=" space-y-16 md:space-y-24 flex uppercase flex-col text-lg mt-12">
                        <a onClick={() => setClick(!Click)} className="" href="/">Home</a>
                        <a onClick={() => setClick(!Click)} className="" href="/About">About</a>
                        <a onClick={() => setClick(!Click)} className="" href="/Services">Services</a>
                        <a onClick={() => setClick(!Click)} className="" href="/Contact">Contact</a>
                        <button onClick={() => {
                            window.location.href = 'mailto:mai.kieu@m2precisionmachining.com';
                        }}
                            className="hover:bg-black group  transition ease-out duration-200 cursor-pointer px-4 py-3 border-black border-2 capitalize tracking-wide">
                            <a className="group-hover:text-white">Request Quote</a>
                        </button>
                    </div>
                </nav>
                : null
            }
        </div>
    );
};


export default Navbar;